/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { PassportDetailsResponse } from '../models/passport-details-response';
import { PassportScannerRequest } from '../models/passport-scanner-request';

/**
 * passport scanner apis
 */
@Injectable({ providedIn: 'root' })
export class PassportService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getPassengerDetailsFromMrz()` */
  static readonly GetPassengerDetailsFromMrzPath =
    '/api/v1/passports/parse-mrz';

  /**
   * Show passport details.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPassengerDetailsFromMrz()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getPassengerDetailsFromMrz$Response(
    params: {
      body: PassportScannerRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<PassportDetailsResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      PassportService.GetPassengerDetailsFromMrzPath,
      'post'
    );
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<PassportDetailsResponse>;
        })
      );
  }

  /**
   * Show passport details.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPassengerDetailsFromMrz$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getPassengerDetailsFromMrz(
    params: {
      body: PassportScannerRequest;
    },
    context?: HttpContext
  ): Observable<PassportDetailsResponse> {
    return this.getPassengerDetailsFromMrz$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<PassportDetailsResponse>
        ): PassportDetailsResponse => r.body
      )
    );
  }
}
